var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7595 22.27H8.8895C13.3295 22.27 15.4695 20.52 15.8395 16.6C15.8795 16.19 15.5795 15.82 15.1595 15.78C14.7495 15.74 14.3795 16.05 14.3395 16.46C14.0495 19.6 12.5695 20.77 8.8795 20.77H8.7495C4.6795 20.77 3.2395 19.33 3.2395 15.26V8.73998C3.2395 4.66998 4.6795 3.22998 8.7495 3.22998H8.8795C12.5895 3.22998 14.0695 4.41998 14.3395 7.61998C14.3895 8.02998 14.7295 8.33998 15.1595 8.29998C15.5795 8.26998 15.8795 7.89998 15.8495 7.48998C15.5095 3.50998 13.3595 1.72998 8.8895 1.72998H8.7595C3.8495 1.72998 1.7495 3.82998 1.7495 8.73998V15.26C1.7495 20.17 3.8495 22.27 8.7595 22.27Z",
    fill: "#009769"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12 12.75H22C22.41 12.75 22.75 12.41 22.75 12C22.75 11.59 22.41 11.25 22 11.25H9.12C8.71 11.25 8.37 11.59 8.37 12C8.37 12.41 8.7 12.75 9.12 12.75Z",
    fill: "#009769"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3502 16.1001C11.5402 16.1001 11.7302 16.0301 11.8802 15.8801C12.1702 15.5901 12.1702 15.1101 11.8802 14.8201L9.06016 12.0001L11.8802 9.18009C12.1702 8.89009 12.1702 8.41009 11.8802 8.12009C11.5902 7.83009 11.1102 7.83009 10.8202 8.12009L7.47016 11.4701C7.18016 11.7601 7.18016 12.2401 7.47016 12.5301L10.8202 15.8801C10.9702 16.0301 11.1602 16.1001 11.3502 16.1001Z",
    fill: "#009769"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.c0847d9abe4e6fce293295555278f3fa.svg";
export { ForwardRef as ReactComponent };